/* AGC PlantBox installation add-on. Loaded site-wide from layout/theme.liquid.
 *
 * 1. PDP (snippets/agc-plantbox-install.liquid): when the tick box is on, the
 *    PlantBox and its matching installation variant are added in ONE
 *    /cart/add.js request, both carrying the same hidden `_agc_install_link`.
 *    Unticked, this script does nothing and Symmetry's own submit runs.
 * 2. Cart (drawer + page): after every refresh, installation lines are kept in
 *    step with their PlantBox line.
 *      - PlantBox removed            -> its installation is removed
 *      - PlantBox quantity changed   -> installation quantity follows
 *      - installation removed        -> PlantBox loses "Installation: Included"
 *    Installation quantity can't be edited on its own (controls hidden in CSS).
 */
(function () {
  if (window.__agcPbInstall) return;
  window.__agcPbInstall = true;

  var INSTALL_HANDLE = 'plantbox-installation';
  var LINK = '_agc_install_link';
  var FLAG = 'Installation';
  var FLAG_VALUE = 'Included';

  function readData(box) {
    try {
      return JSON.parse(box.querySelector('.js-agc-pb-install-data').textContent);
    } catch (e) {
      return null;
    }
  }

  function boxFor(form) {
    var scope = form.closest('.shopify-section') || form.closest('product-form') || document;
    return scope.querySelector('[data-agc-pb-install]');
  }

  /* ---------------------------------------------------------------- PDP --- */

  document.addEventListener('on:variant:change', function (evt) {
    var section = evt.target.closest('.shopify-section') || document;
    var box = section.querySelector('[data-agc-pb-install]');
    if (!box || !evt.detail || !evt.detail.variant) return;
    var data = readData(box);
    if (!data) return;
    var idx = data.variantToIndex[evt.detail.variant.id];
    var inst = data.installs[idx];
    var priceEl = box.querySelector('.js-agc-pb-install-price');
    if (inst && priceEl) priceEl.textContent = '+ ' + inst.price;
  });

  function newLinkId() {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  }

  function collectProperties(fd) {
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && typeof value === 'string') props[m[1]] = value;
    });
    return props;
  }

  // Capture phase on document runs before Symmetry's listener on the form,
  // so stopPropagation keeps the theme from adding the PlantBox a second time.
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || !form.classList || !form.classList.contains('js-product-form')) return;
    var box = boxFor(form);
    if (!box) return;
    var checkbox = box.querySelector('.js-agc-pb-install');
    if (!checkbox || !checkbox.checked) return;
    var data = readData(box);
    if (!data) return;

    var fd = new FormData(form);
    var variantId = parseInt(fd.get('id'), 10);
    var inst = data.installs[data.variantToIndex[variantId]];
    if (!variantId || !inst || !inst.id) return; // fall back to the normal add

    evt.preventDefault();
    evt.stopPropagation();
    addWithInstallation(form, fd, variantId, inst.id);
  }, true);

  function addWithInstallation(form, fd, variantId, installVariantId) {
    var productForm = form.closest('product-form');
    var submitBtn = form.querySelector('[name="add"]') || (productForm && productForm.querySelector('[name="add"]'));
    if (submitBtn && submitBtn.getAttribute('aria-disabled') === 'true') return;

    var setError = function (msg) {
      if (productForm && typeof productForm.setErrorMsgState === 'function') productForm.setErrorMsgState(msg);
    };
    setError(false);
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.classList.add('is-loading');
    }

    var quantity = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    var link = newLinkId();
    var props = collectProperties(fd);
    props[FLAG] = FLAG_VALUE;
    props[LINK] = link;

    var sectionsToUpdate = ['page-header', 'cart-drawer']
      .map(function (sel) { return document.querySelector(sel); })
      .filter(Boolean);

    var body = {
      items: [
        { id: variantId, quantity: quantity, properties: props },
        { id: installVariantId, quantity: quantity, properties: { _agc_install_link: link } }
      ],
      sections: sectionsToUpdate.map(function (el) { return el.dataset.sectionId; }).join(','),
      sections_url: window.location.pathname
    };

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      })
      .then(function (r) {
        var data = r.json || {};
        if (!r.ok || data.status) {
          var err = typeof data.description === 'string' ? data.description : (data.message || 'Could not add to cart');
          throw new Error(err);
        }

        if (document.querySelector('.template-cart')) {
          var cartForm = document.querySelector('cart-form');
          if (cartForm && cartForm.enableAjaxUpdate) cartForm.refresh();
        } else if (theme.settings.afterAddToCart === 'page') {
          setTimeout(function () { window.location.href = theme.routes.cart; }, 300);
        } else {
          if (data.sections && sectionsToUpdate.length === Object.keys(data.sections).length) {
            sectionsToUpdate.forEach(function (el) { el.updateFromCartChange(data.sections[el.dataset.sectionId]); });
          } else {
            form.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
          }
          if (theme.settings.afterAddToCart === 'drawer') {
            var drawer = document.querySelector('.js-cart-drawer');
            if (drawer) drawer.open(submitBtn);
          } else if (theme.settings.afterAddToCart === 'notification') {
            var tpl = document.getElementById('AddedNotification');
            if (tpl) {
              var note = tpl.content.firstElementChild.cloneNode(true);
              var first = (data.items || [])[0];
              note.dataset.productTitle = first ? first.product_title : '';
              (document.querySelector('.pageheader--sticky') || document.body).appendChild(note);
            }
          }
        }

        form.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: variantId } }));

        if (submitBtn) {
          submitBtn.classList.add('is-success');
          submitBtn.removeAttribute('aria-disabled');
          setTimeout(function () {
            submitBtn.classList.remove('is-loading');
            submitBtn.classList.remove('is-success');
          }, 2000);
        }
      })
      .catch(function (error) {
        setError(error.message);
        form.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: error.message } }));
        form.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        if (submitBtn) {
          submitBtn.classList.remove('is-loading');
          submitBtn.classList.remove('is-success');
          submitBtn.removeAttribute('aria-disabled');
        }
      });
  }

  /* --------------------------------------------------------------- Cart --- */

  var syncing = false;
  var pending = false;
  var recentSyncs = [];

  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      return res.json();
    });
  }

  function lockInstallQuantity() {
    document.querySelectorAll('.cart-item.product-' + INSTALL_HANDLE + ' .cart-item__quantity-input').forEach(function (input) {
      input.readOnly = true;
      input.tabIndex = -1;
    });
  }

  function syncCart() {
    lockInstallQuantity();
    if (syncing) { pending = true; return; }
    // Loop guard: a sync that changes the cart triggers one more refresh, so
    // allow a few per few seconds, never an endless cycle.
    var now = Date.now();
    recentSyncs = recentSyncs.filter(function (t) { return now - t < 5000; });
    if (recentSyncs.length >= 4) return;
    recentSyncs.push(now);
    syncing = true;

    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var parents = {};
        var installs = [];
        cart.items.forEach(function (item) {
          var link = item.properties && item.properties[LINK];
          // An installation with no link was added on its own (e.g. from its
          // product URL); it has no PlantBox, so it is removed below.
          if (item.handle === INSTALL_HANDLE) installs.push(item);
          else if (link) parents[link] = item;
        });

        var updates = {};
        var hasUpdates = false;
        var covered = {};
        installs.forEach(function (ins) {
          var link = ins.properties && ins.properties[LINK];
          var parent = link ? parents[link] : null;
          if (!parent || covered[link]) {
            updates[ins.key] = 0;
            hasUpdates = true;
          } else {
            covered[link] = true;
            if (ins.quantity !== parent.quantity) {
              updates[ins.key] = parent.quantity;
              hasUpdates = true;
            }
          }
        });

        // PlantBox lines whose installation the customer removed.
        var stripped = Object.keys(parents)
          .filter(function (link) { return !covered[link]; })
          .map(function (link) { return parents[link]; });

        var chain = Promise.resolve();
        if (hasUpdates) {
          chain = chain.then(function () { return postJson(window.Shopify.routes.root + 'cart/update.js', { updates: updates }); });
        }
        stripped.forEach(function (item) {
          // /cart/change.js ignores an empty properties object and keeps the
          // old values; the keys must be sent as null to clear them.
          var props = {};
          Object.keys(item.properties || {}).forEach(function (k) {
            if (item.properties[k] !== null) props[k] = item.properties[k];
          });
          props[LINK] = null;
          props[FLAG] = null;
          chain = chain.then(function () {
            return postJson(window.Shopify.routes.root + 'cart/change.js', { id: item.key, quantity: item.quantity, properties: props });
          });
        });

        return chain.then(function () { return hasUpdates || stripped.length > 0; });
      })
      .then(function (changed) {
        syncing = false;
        if (changed) document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true, cancelable: false }));
        else if (pending) { pending = false; syncCart(); }
      })
      .catch(function (e) {
        syncing = false;
        pending = false;
        // eslint-disable-next-line no-console
        console.warn('[agc-pb-install] cart sync failed', e);
      });
  }

  document.addEventListener('on:cart:after-merge', syncCart);

  function onReady() {
    lockInstallQuantity();
    if (window.AGC_PB_INSTALL_IN_CART) syncCart();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady);
  else onReady();
})();
